<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content buddy-content" @click="closeLevel2()">
      <student-header class="filled" :navbarmode.sync="navbarMode" ref="lmsv4header" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-20">
          <div class="d-flex align-items-center mg-b-20">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style4 mg-b-10">
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyAdminDashboard' }" class="tx-11" style="color: #444">Onboarding</router-link></li>
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyAdminReport' }" class="tx-11" style="color: #444">Тайлан</router-link></li>
                <li class="breadcrumb-item active tx-14" aria-current="page">{{ getFieldFromConstants('title') }}</li>
              </ol>
            </nav>
            <div class="mg-l-auto">
              <depart-cascader v-model="filterDepartId" :id="filterDepartId" :key="filterDepartKey" @on-change="departChanged" checkStrictly size="large" ></depart-cascader>
            </div>
          </div>
          

          <div class="check-outer check-more wd-100p">
            <div v-for="(n, i) in departs" :class="`mg-b-10 check-item check-code-${$route.params.id} pd-x-40 pd-y-20`" >
              <div class="text-center tx-semibold tx-14 mg-b-10 check-title">
              <!-- {{ i==0? 'Мэдээлэл технологийн газар':'Стратеги хамтийн ажиллагааны хэлтэс' }} -->
              {{ n.name }}
              </div>
              
              <vc-donut
              :sections="[
                {
                  value: 21,
                  color: i==0 ? 'white':'#2856a8',
                },
              ]"
              :background="i==0 ? getFieldFromConstants('bgColor') : '#FFFFFF'"
              :foreground="i==0 ? getFieldFromConstants('borderColor') : '#fae1e8'"
              :size="70"
              unit="%"
              :thickness="12"
              :total="100"
              :start-angle="0"
            >
              <div class="tx-semibold">
                <div class="tx-lg-28 tx-md-20 tx-sm-16 tx-xs-14" v-html="`${n.progress.toFixed(1)}%`">
                </div>
                <div class="tx-lg-16 tx-md-14 tx-sm-12 tx-xs-8 tx-color-03">{{n.doneCheckCount}}/{{ n.allCheckCount }}</div>
              </div>
            </vc-donut>

            
            <div  style="left: 50%; transform: translate(-50%, 0%);" class="text-center pos-absolute tx-semibold b-20">
              <div @click="$router.push({name: 'buddyAdminReportCheck', params: { id: n.id, code: $route.params.id } })" role="button"
              :class="`rounded-30 bg-${i>0?'black':'white'}-1 pd-x-30 pd-y-6`">
                Checklist
              </div>
              <div @click="$router.push({name: 'buddyAdminReportDepart', params: { id: n.id, code: $route.params.id } })" role="button"
              :class="`rounded-30 bg-${i>0?'black':'white'}-1 pd-x-30 pd-y-6 mg-t-10`">
                Нэгж
              </div>
            </div>
            </div>
          </div>

        </div>

      </vue-custom-scrollbar>
    </div>

      <vue-custom-scrollbar
        class="lms-sidebar-right"
      >
        <div class="lms-sidebar-right-header">
          <div class="pos-absolute r-20 t-20">
            <div :class="`dropdown dropdown-profile`" v-show="$route.name=='buddyParticipant'">
                <a href class="dropdown-link" data-toggle="dropdown">
                  <img :src="`${myResBaseUrl}v4-assets/icon1.png`" />
                </a>
                <div class="divide-y dropdown-menu dropdown-menu-right tx-13">
                  <router-link to="/lms/profile" class="dropdown-item pd-l-0-f mg-b-15" role="button">
                    <feather type="user" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Профайл
                  </router-link>
                  <a @click="logout" class="dropdown-item pd-l-0-f mg-t-0-f" role="button">
                    <feather type="log-out" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Гарах
                  </a>
                </div>
              </div>
          </div>
          <a >
            <part-user-sidebar :mustJoinCourses="mustJoinCourses"></part-user-sidebar>
          </a>
        </div>
        
        <div class="lms-sidebar-right-body">

          <vc-calendar is-expanded title-position="left" color="red" /> 
        </div>

        <div class="lms-sidebar-right-footer">
        </div>
      </vue-custom-scrollbar>
    </div>

    

  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import contstants from "@/constants";

export default {
  components: {
    vueCustomScrollbar,
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    departCascader: () => ({
      component: import("@/components/modules/hr/departCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
  },
  data() {
    return {
      buddyLevels: contstants.levels,
      myResBaseUrl: "https://res.gosmart.mn/",
      navbarMode: 0,
      bgColors:[
        '#9627DD', '#17A0E2', '#e04a69', '#12A0A1'
      ],
      borderColors:[
        '#CD81FF', '#31B6FD', '#E63459', '#32BBBC'
      ],
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      filterDepartId: null,
      filterDepartKey: 0,
      departs: []
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.filterDepartId= this.$store.state.user.userInfo.departId;
    this.$nextTick(()=>{
      this.filterDepartKey++;
    });
    
    this.init();
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    getFieldFromConstants(field){
      let rv='';
      if(this.buddyLevels.filter(x=>x.code==this.$route.params.id).length ){
        rv= this.buddyLevels.filter(x=>x.code==this.$route.params.id)[0][field];
      }
      return rv
    },
    departChanged(e){
      // console.log('departChanged', e);
      this.filterDepartId= e;
      this.init();
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init(reset) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "buddy/admin/GetDepartSummary" },
        data: { 
          departId: this.filterDepartId,
          boxCode: this.$route.params.id
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.departs= res.data.list;
          // console.log('GetDepartSummary', res.data);
        }
      });
    },
    
  },
};
</script>